import { Mutation, Visitor } from 'graphql/generated/graphqlTypes';
import { generateMockVisitor } from 'mocks/graphqlMocks/visitor';

export function mockedSetInstallerData(setInstaller: Visitor): Pick<Mutation, 'setInstaller'> {
  return {
    setInstaller
  };
}

export const mockedSetInstallerDataForMutation = mockedSetInstallerData(
  generateMockVisitor({
    id: 'mockedInstallerIdNew',
    name: 'mockedInstallerNameNew',
    email: 'mockedInstallerEmailNew'
  })
);
